import CustomerId               from "../../../../domain/customer/CustomerId";
import FetchStatusRepository    from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository         from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CustomerRecord           from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordRepository from "../../../../domain/record/customer/CustomerRecordRepository";
import FetchStatusDataSource    from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource         from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import CustomerRecordDataSource from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";
import RouterDispatcher         from "../../../../infrastructure/redux/router/RouterDispatcher";

class UpdateCustomerRecord {
  private readonly repository: CustomerRecordRepository = new CustomerRecordDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(customerId: CustomerId, customerRecord: CustomerRecord) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.update(customerId, customerRecord);
      this.notifyRepository.saveSuccess();
      this.routerDispatcher.customerRecords();
    } catch (e) {
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdateCustomerRecord;
